define('views/base/collection',['require','underscore','chaplin','views/base/view'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        View = require('views/base/view');

    var CollectionView = Chaplin.CollectionView.extend({
        getTemplateFunction: View.prototype.getTemplateFunction,
        getTemplateData: function() {
            return _.merge(
                View.prototype.getTemplateData.apply(this, arguments),
                Chaplin.CollectionView.prototype.getTemplateData.apply(this, arguments)
            );
        }
    });

    return CollectionView;
});

